import { cgx } from "@springcare/dsm";
/**
 * Based on
 * https://www.figma.com/file/iPT3o294qUihaibhONRB2g/Verdant-Foundations?node-id=127%3A577&t=2TGnLwAnczPaiSOm-0
 */
export var textStyles = cgx.textStyles;
